<template>
  <div class="lootbox-boxes">
    <div class="lootbox-boxes-alert">
      <IInfo width="14" />Loot Boxes are non refundable and do not qualify for the ETH back guarantee
    </div>
    <LootBoxBoxesRow
      :items="legendaryBoxes"
      type="legendary"
      name="Legendary box"
      scroll-button="View legendary loot box Scroll"
      :buying-item="buyingItem && buyingItem.type === 'legendary' ? buyingItem : null"
      @buy="onBuy('legendary', $event)"
      @openScroll="openBoxList('legendary')"
    />
    <LootBoxBoxesRow
      :items="epicBoxes"
      type="epic"
      name="Epic box"
      scroll-button="View epic loot box Scroll"
      :buying-item="buyingItem && buyingItem.type === 'epic' ? buyingItem : null"
      @buy="onBuy('epic', $event)"
      @openScroll="openBoxList('epic')"
    />

    <img
      class="lootbox-boxes-bg"
      src="@/assets/img/lootbox/lootbox-boxes-bg.svg"
      alt="bg"
    >
  </div>
</template>
<script>
import { ModalName } from "@/components/Modal/modal-name"
import { useModal } from "@/composables/useModal"
import { openLootBox } from "@/functions/openLootBox"
import { computed, defineComponent, ref } from "vue"
import LootBoxBoxesRow from "./LootBoxBoxesRow.vue"
import IInfo from "@/assets/img/info.svg?inline"
import { useWeb3Store } from "@/store/web3"
import { connectWallet } from "@/web3"
export default defineComponent({
    props: {
        epicBoxPrice: Number,
        legendaryBoxPrice: Number
    },
    components: { LootBoxBoxesRow, IInfo },
    setup(props) {
        const web3Store = useWeb3Store()
        const epicBoxes = computed(() => [
            {
                price: `0.1 ETH `,
                btn: '1 box',
                amount: 1,
                image: require('@/assets/img/lootbox/lootbox-epic.jpg')
            },
            {
                price: `0.45 ETH`,
                btn: '5 boxes',
                amount: 5,

                image: require('@/assets/img/lootbox/lootbox-epic-5.jpg')
            },
            {
                price: `0.83 ETH`,
                btn: '11 boxes',
                amount: 11,

                image: require('@/assets/img/lootbox/lootbox-epic-11.jpg')
            },
        ])
        const legendaryBoxes = computed(() => [
            {
                price: `0.25 ETH `,
                btn: '1 box',
                amount: 1,

                image: require('@/assets/img/lootbox/lootbox-legendary.jpg')
            },
            {
                price: `1.13 ETH`,
                btn: '5 boxes',
                amount: 5,

                image: require('@/assets/img/lootbox/lootbox-legendary-5.jpg')
            },
            {
                price: `2.07 ETH`,
                btn: '11 boxes',
                amount: 11,

                image: require('@/assets/img/lootbox/lootbox-legendary-11.jpg')
            },
        ])
        const isBuying = ref(false)
        const buyingItem = ref()
        const onBuy = async (type, box) => {
            if (isBuying.value) return
            if (!web3Store.isConnected) {
                const done = await connectWallet()
                if (!done) return
            }
            const { price, amount } = box
            isBuying.value = true
            buyingItem.value = { ...box, type }
            try {
                await openLootBox({ type, price, amount })
            } catch (err) {
                console.error(err)
            }
            isBuying.value = false
            buyingItem.value = null

        }
        const openBoxList = (type) => {
            useModal().open({ name: ModalName.LootBoxListModal, props: { type } })
        }
        return {
            buyingItem,
            isBuying,
            openBoxList,
            legendaryBoxes,
            epicBoxes, onBuy
        }
    }
})
</script>
<style lang="scss">
.lootbox-boxes {
    position: relative;
    &-alert {
        color: #fff;
        opacity: 0.5;
        font-weight: bold;
        margin-bottom: 15px;
        display: flex;

        svg {
            flex-shrink: 0;
            margin-right: 5px;
            height: 20px;
        }
        @media screen and (max-width: 576px) {
            font-size: 12px;
        }
    }
    &-bg {
        position: absolute;
        z-index: -1;
        width: 1100px;
        top: -60%;
        right: -30%;
    }
}
</style>